module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodsnow-234170d71aeb29e6d06aa12e1162bb0c.webp";